module.exports = __webpack_public_path__ + "static/media/purple_circle.8e4b1353.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Buildings/Manage/Map/Marker/img/purple_circle.png
// module id = 1129
// module chunks = 0